import request from "@/util/request";
export function GetDItemSelect(data) {
  return request({
    url: "/api/BaseData/GetDItemSelect?t=" + +new Date(),
    method: "get",
    params: data,
  });
}
export function GetStationTree(data) {
  return request({
    url: "/api/BaseData/GetStationTree?t=" + +new Date(),
    method: "get",
    params: data,
  });
}
export function GetGroupSelect(data) {
  return request({
    url: "/api/BaseData/GetGroupSelect?t=" + +new Date(),
    method: "get",
    params: data,
  });
}
export function GetGroupTree(data) {
  return request({
    url: "/api/BaseData/GetGroupTree?t=" + +new Date(),
    method: "get",
    params: data,
  });
}
export function GetDItemTree(data) {
  return request({
    url: "/api/BaseData/GetDItemTree?t=" + +new Date(),
    method: "get",
    params: data,
  });
}
export function GetStationSelector(data) {
  return request({
    url: "/api/BaseData/GetStationSelector?t=" + +new Date(),
    method: "get",
    params: data,
  });
}
export function GetParentLevelStationTree(data) {
  return request({
    url: "/api/BaseData/GetParentLevelStationTree?t=" + +new Date(),
    method: "post",
    data,
  });
}
export function GetStationSelect(data) {
  return request({
    url: "/api/BaseData/GetStationSelect?t=" + +new Date(),
    method: "get",
    params: data,
  });
}
export function GetPageDItemSelect(data) {
  return request({
    url: "/api/BaseData/GetPageDItemSelect?t=" + +new Date(),
    method: "get",
    params: data,
  });
}
export function GetTrafficCategorySelect(data) {
  return request({
    url: "/api/BaseData/GetTrafficCategorySelect?t=" + +new Date(),
    method: "get",
    params: data,
  });
}
export function GetDeviceSelect(data) {
  return request({
    url: "/api/BaseData/GetDeviceSelect?t=" + +new Date(),
    method: "get",
    params: data,
  });
}

// [下拉]获取单位
export function GetUnitSelect(data) {
  return request({
    url: "/api/BaseData/GetUnitSelect?t=" + +new Date(),
    method: "GET",
    params: data,
  });
}

// [下拉]获取报警类型
export function GetAlarmRuleSelect(data) {
  return request({
    url: "/api/BaseData/GetAlarmRuleSelect?t=" + +new Date(),
    method: "GET",
    params: data,
  });
}
// [下拉]获取报警状态
export function GetAlarmStateSelect(data) {
  return request({
    url: "/api/BaseData/GetAlarmStateSelect?t=" + +new Date(),
    method: "GET",
    params: data,
  });
}

// [下拉]获取站点标签
export function GetFunctionCategorySelect(data) {
  return request({
    url: "/api/BaseData/GetFunctionCategorySelect?t=" + +new Date(),
    method: "GET",
    params: data,
  });
}
export function GetStationTypeSelect(data) {
  return request({
    url: "/api/BaseData/GetStationTypeSelect?t=" + +new Date(),
    method: "GET",
    params: data,
  });
}

// [下拉]获取消息发送器
export function GetMessageSenderSelect(data) {
  return request({
    url: "/api/BaseData/GetMessageSenderSelect?t=" + +new Date(),
    method: "GET",
    params: data,
  });
}

// [下拉]获取报警级别
export function GetAlarmLevelSelect(data) {
  return request({
    url: "/api/BaseData/GetAlarmLevelSelect?t=" + +new Date(),
    method: "GET",
    params: data,
  });
}

// [下拉]获取报警推送时间
export function GetAlarmPushTimeRangeSelect(data) {
  return request({
    url: "/api/BaseData/GetAlarmPushTimeRangeSelect?t=" + +new Date(),
    method: "GET",
    params: data,
  });
}

export function GetStationDeviceSelect(data) {
  return request({
    url: "/api/BaseData/GetStationDeviceSelect?t=" + +new Date(),
    method: "GET",
    params: data,
  });
}

export function GetControlCommandStateSelect(data) {
  return request({
    url: "/api/BaseData/GetControlCommandStateSelect?t=" + +new Date(),
    method: "GET",
    params: data,
  });
}

export function GetStationStandard(data) {
  return request({
    url: "/api/BaseData/GetStationStandard?t=" + +new Date(),
    method: "GET",
    params: data,
  });
}

export function GetFunctionAreaStandard(data) {
  return request({
    url: "/api/BaseData/GetFunctionAreaStandard?t=" + +new Date(),
    method: "GET",
    params: data,
  });
}
export function GetSystemInfo(data) {
  return request({
    url: "/api/BaseData/GetSystemInfo?t=" + +new Date(),
    method: "GET",
    params: data,
  });
}

// [下拉]获取因子标签
export function GetDItemTagSelect(data) {
  return request({
    url: "/api/BaseData/GetDItemTagSelect?" + +new Date(),
    method: "GET",
    params: data,
  });
}
// [下拉]获取站点标签
export function GetStationTagSelect(data) {
  return request({
    url: "/api/BaseData/GetStationTagSelect?" + +new Date(),
    method: "GET",
    params: data,
  });
}

// [下拉]获取单位类型
export function GetEnterpriseTypeSelect(data) {
  return request({
    url: "/api/BaseData/GetEnterpriseTypeSelect?t=" + +new Date(),
    method: "GET",
    params: data,
  });
}
// [下拉]获取单位类型
export function GetChildAreaSelect(data) {
  return request({
    url: "/api/BaseData/GetChildAreaSelect?t=" + +new Date(),
    method: "GET",
    params: data,
  });
}
export function GetDItemSelector(data) {
  return request({
    url: "/api/BaseData/GetDItemSelector?t=" + +new Date(),
    method: "GET",
    params: data,
  });
}
// [下拉]获取污染源类型
export function GetPollutionSourcesTypeSelect(data) {
  return request({
    url: "/api/BaseData/GetPollutionSourcesTypeSelect?t=" + +new Date(),
    method: "GET",
    params: data,
  });
}

// [下拉]获取行业类型
export function GetIndustryTypeSelect(data) {
  return request({
    url: "/api/BaseData/GetIndustryTypeSelect?t=" + +new Date(),
    method: "GET",
    params: data,
  });
}
export function GetRiverSelect(data) {
  return request({
    url: "/api/BaseData/GetRiverSelect?t=" + +new Date(),
    method: "GET",
    params: data,
  });
}
export function GetAssessmentTypeSelect(data) {
  return request({
    url: "/api/BaseData/GetAssessmentTypeSelect?t=" + +new Date(),
    method: "GET",
    params: data,
  });
}
export function getCommonEnums(data) {
  return request({
    url: "/water-quality-web/common/getCommonEnums?t=" + +new Date(),
    method: "get",
    params: data
  });
}
export function GetRulWaterLevelSelect(data) {
  return request({
    url: "/api/BaseData/GetRulWaterLevelSelect?t=" + +new Date(),
    method: "get",
    params: data
  });
}
export function GetRegulatoryTypeSelect(data) {
  return request({
    url: "/api/BaseData/GetRegulatoryTypeSelect?t=" + +new Date(),
    method: "get",
    params: data
  });
}

export function GetUserSelect(data) {
  return request({
    url: "/api/BaseData/GetUserSelect?t=" + +new Date(),
    method: "get",
    params: data
  });
}



// WEBPACK FOOTER //
// ./src/api/baseData.js